import { Injectable } from "@angular/core";
import "rxjs";
import { BehaviorSubject, Observable } from "rxjs";
import { Router } from "@angular/router";
import {
  Http,
  Response,
  URLSearchParams,
  Headers,
  RequestOptions
} from "@angular/http";

import { HttpService } from "./http.interceptor.service";
import { Config } from "../../../config";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "./shared.service";
import { of } from "rxjs/observable/of";
import { GenericClass } from "../extClasses/genericMethod";

let config = new Config();

@Injectable()
export class UserInfoService {
  constructor(private http: Http, private HTTP: HttpService) {}
  _info: any = null;
  userPermissions : any = {};
  observableUserInfo = new BehaviorSubject<any[]>(this._info);
  
  get() {
    return this._info || {};
  }
  set(info) {
    this._info = info;
    this.setUserPermissions();
  }
  reset() {
    this._info = null;
    this.authToken.clear();
  }

  setUserPermissions(){
    if(this._info.Permissions && this._info.Permissions.length > 0){
      let currPermission:string = "";
      let userAllowedPermissionsList:string = this._info.Permissions.join().toLowerCase().split(",");
      
      for(let key in GenericClass.permissionObj){
        currPermission = GenericClass.permissionObj[key].toLowerCase();
        this.userPermissions[key] = false;

        if(userAllowedPermissionsList.includes(currPermission)){
          this.userPermissions[key] = true;
        }
      }
    }
    this.observableUserInfo.next(this._info);
  }

  authToken = {
    _token: null,
    set: function(token: string) {
      this._token = localStorage.setItem("id_token", token);
    },
    get: function() {
      if (localStorage.getItem("id_token") && !this._token) {
        this._token = localStorage.getItem("id_token");
      }
      return localStorage.getItem("id_token");
    },
    clear: function() {
      localStorage.removeItem("id_token");
      this._token = null;
    },
    isSet: function() {
      return this.get() ? true : false;
    }
  };
}

@Injectable()
export class SecurityService {
  constructor(
    private HTTP: HttpService,
    private userInfoService: UserInfoService,
    private router: Router,
    private translate: TranslateService
  ) {}
  _fetched: boolean = false;
  requiredAuthorizedUser(): Observable<boolean> {
    if (!this._fetched) {
      return this.HTTP.get("Account/Me").map(response => {
        this.userInfoService.set(response.json().data);
        this._fetched = true;
        return response.ok;
      });
    } else {
      return Observable.of(true);
    }
  }

  logout() {
    this.userInfoService.authToken.clear();
    localStorage.clear();
    this._fetched = false;
  }
}

@Injectable()
export class GetToken {
  constructor(
    private HTTP: HttpService,
    private userInfoService: UserInfoService,
    private router: Router,
    private sharedService: SharedService
  ) {}
  fetchUserToken(token, companycode,bool, previousCompanyCode?): Observable<boolean> {
    
    return this.HTTP.get(
      "Account/ValidateJwtToken?JwtToken=" +
        token +
        "&CompanyCode=" +
        companycode
    ).map(response => {
      // this.userInfoService.set(response.json().data);
      // localStorage.setItem('id_token', response.json().data.UserToken)
      var officeIdArray = [];
      if (response.json().data.OfficeList.length >= 1) {
        response.json().data.OfficeList.forEach(office => {
          officeIdArray.push(office.Id);
        });
      }
      this.sharedService.setProjectTitle(response.json().data.CompanyName);
      this.userInfoService.set(response.json().data);
      // localStorage.setItem("id_token", token);
      if(!bool){
      if (!previousCompanyCode || previousCompanyCode != companycode) {
        if (companycode) {
          localStorage.setItem("companycode", companycode);
        }
        if (response.json().data.OfficeList.length >= 1) {
          
          localStorage.setItem(
            "officeId",
            response.json().data.OfficeList[0].Id
          );
        } else {
          
          localStorage.setItem("officeId", "");
        }
        if (officeIdArray.length >= 1) {
          
          localStorage.setItem("officeIds", officeIdArray.toString());
        } else {
          
          localStorage.setItem("officeIds", "");
        }
      }
    }
      localStorage.setItem(
        "primaryColor",
        response.json().data.PrimaryBrandingColor
      );
      localStorage.setItem(
        "secondaryColor",
        response.json().data.SecondaryBrandingColor
      );
      return response.ok;
    })
    .catch((error) =>
      {
        var message = JSON.parse(error._body)
        if(error.status == 501 && message.message == 'Not allowed')
        {
          message.message = 'this is not a dead end. Looks like you tried to open a page which is not shared with you by company admin.'
          message['message1']='Please get the required access from company admin and try again.'
          this.sharedService.setErrorMessage(message);
          this.router.navigate(['error']);
          return of(false);
        }
        return Observable.throw(error);
      });
  }

    /**
   * Get company details like (companyCode, JobRocketApiUrl, JobRocketApiAuthorizationBearer, JobRocketClientUrl)
   */
  fetchCompanyDetails(companycode){
    var config = new Config();
    return this.HTTP.get( "Account/ValidateCompanyToken?CompanyCode=" + companycode
    ).map((companDetails) => {
      return companDetails.json().data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/security.service.ts